export const KNOWN_ISSUES_VIEW = 'known-issues';

export const HELP_CENTER_ROUTE_PATHS = {
  knownIssues: '/help-center/known-issues',
};

export const HELP_CENTER_API_PATHS = {
  list: '/v1/api/platform/help-center/known-issues',
  create: '/v1/api/platform/help-center/known-issues',
  update: '/v1/api/platform/help-center/known-issues/:knownIssueId',
};

export const PAGE_SIZE = 25;

/**
 * Query keys for React Query.
 * Hierarchical structure for cache management.
 */
export const KnownIssuesKeys = {
  all: () => ['help-center', 'known-issues'] as const,
  list: (page: number, filters: Record<string, unknown> = {}) =>
    [...KnownIssuesKeys.all(), 'list', page, filters] as const,
};
